import {EventTotalGuests} from '@wix/ambassador-events-ui-v1-widget-data/types'
import {State} from '../types/state'

export const getEventTotalGuests = (state: State, eventId: string): EventTotalGuests | undefined => {
  const {totalGuests} = state.totalGuests ?? {}
  return totalGuests?.[eventId]
}

export const getEventAttendingGuests = (state: State, eventId: string): number | undefined => {
  const totalGuests = getEventTotalGuests(state, eventId)
  return totalGuests?.attending ?? 0
}
